import React from 'react';
import { MenuItem } from 'react-bootstrap';

import NavBarLink from './NavBarLink';
import { can, permActions } from 'permissions';
import { getSubStatus } from 'helpers/subs';
import { withSimoSub } from 'decorators/withSub';
import { showActivateSub } from 'helpers/portLinks/simo';

let NavBarSimo = ({ sub, loggedInUser }) => {
  if (!sub) {
    return null;
  }

  const subStatus = getSubStatus(sub);
  const isExpired = subStatus === 'expired';
  const isNew = subStatus === 'new';
  const isActive = subStatus === 'active';

  const links = [
    {
      to: `/simo/subscriptions/${sub.id}/activate`,
      label: 'Activate Subscription',
      condition: showActivateSub(subStatus),
    },
    {
      to: `/simo/subscriptions/${sub.id}/upgrade-invoice`,
      label: 'Upgrade Invoice',
      condition: isActive,
      permission: can(loggedInUser, permActions.UPGRADE_SIMO_INVOICE),
    },
    {
      to: `/simo/subscriptions/${sub.id}/modify-auto-renew`,
      label: 'Modify Auto Renew',
      condition: !isNew && !isExpired,
    },
    {
      to: `/simo/subscriptions/${sub.id}/expire-subscription`,
      label: 'Expire Subscription',
      condition: !isNew && !isExpired,
      permission: can(loggedInUser, permActions.EXPIRE_SIMO_DEVICE),
    },
  ];

  return (
    <React.Fragment>
      <MenuItem divider />
      <MenuItem disabled>
        <b>
          {sub.first_name} {sub.last_name}
          <br />
          Sub ID: {sub.id}
          <br />
          Device SN: {sub.device_sn}
        </b>
      </MenuItem>
      {links.map((link) => (
        <NavBarLink key={link.to} {...link} />
      ))}
    </React.Fragment>
  );
};

export default withSimoSub(NavBarSimo);
